import React, { useState, useEffect, lazy, Suspense } from "react";
import FormGenerator from "../../common/FormGenerator/FormGenerator";
import { api_url } from "../../../config";
import FormAccount from "./FormAccount";
import FormRdv from "./FormRdv";
import ProgressSection from "./ProgressSection";
import tools from "../../../helpers/tools";
import dataService from "../../../helpers/dataService";
import Loader from "../../common/Loader";
import "./parcours.scss";
// Chargé à la demande : la chaîne @react-pdf pèse plus de la moitié du bundle.
const FormViewerPdf = lazy(() => import("./FormViewerPdf"));

// Une étape du parcours : carte `surface` sur le fond de page, titre de niveau 1.
const EtapeParcours = ({ titre, children }) => (
  <section className="parcours__carte" aria-labelledby="parcours-titre">
    <h1 id="parcours-titre" className="parcours__titre">
      {titre}
    </h1>
    {children}
  </section>
);

const FormRDSP = (props) => {
  const [isAccountFinished, setIsAccountFinished] = useState(false);
  const [isDspFinished, setIsDspFinished] = useState(false);
  const [isRdvFinished, setIsRdvFinished] = useState(false);

  const [userCreated, setUserCreated] = useState(false);
  const [formData, setFormData] = useState(false);
  const [userData, setUserData] = useState(false);
  const [hasDroit, setHasDroit] = useState(false);
  const [checkHasRdspDone, setCheckHasRdspDone] = useState(false);
  const [checkHasRightDone, setCheckHasRightDone] = useState(false);

  const [showRedirectMsg, setShowRedirectMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [origin, setOrigin] = useState(false);
  const [rdspForm, setRdspForm] = useState(false);
  const [showDl, setShowDl] = useState(false);
  const [isConjoint, setIsConjoint] = useState(false);

  function reset() {
    setIsDspFinished(false);
    setIsAccountFinished(false);
    setIsRdvFinished(false);
    //tools.saveState("FormRDSP", "answers", false);
    //tools.saveState("FormRDSP", "step", 0);
  }

  useEffect(() => {
    setShowRedirectMsg(props.location.search == "?redirectfrombo");
    var qs = window.location.search.substring(1);
    qs = tools.parse_query_string(qs);

    if (qs.o) {
      setOrigin(qs.o);
    }
    if (qs.co) {
      setIsConjoint(true);
    }
  }, [props.location.search]);

  useEffect(() => {
    if (isAccountFinished && userData.id && !checkHasRdspDone) {
      //TODO - REMPLACER PAR LE BON CALL
      setCheckHasRdspDone(true);
      dataService.get(
        `rdo/peut-completer?allocataireId=${userData.id}`,
        (data) => {
          setIsDspFinished(!data.peutCompleter);
        },
        (error) => {
          console.error("peut completer error", error);
          setIsDspFinished(true);
        }
      );
    }
  }, [isAccountFinished, userData]);

  useEffect(() => {
    if (isDspFinished && userData.id && !checkHasRightDone) {
      setIsLoading(true);
      dataService.get(
        "recipients/" + userData.id + "/rights",
        (datas) => {
          setCheckHasRightDone(true);
          setHasDroit(datas.isRightsOpen);
        },
        (errors) => {},
        () => {
          setIsLoading(false);
        }
      );
    }
  }, [isDspFinished, userData]);

  return (
    <>
      <ProgressSection
        sections={[
          {
            title: "Identification",
            active: !isAccountFinished,
          },
          {
            title: "RDO",
            active: !isDspFinished && isAccountFinished,
          },
          {
            title: "Récapitulatif",
            active: isAccountFinished && isDspFinished,
          },
        ]}
      />
      <div className="parcours">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {showRedirectMsg && !isAccountFinished && (
              <p className="encart parcours__encart" role="status">
                <i className="fa fa-info-circle" aria-hidden="true" />
                <span>
                  Vous possédez bien un compte ESPOAR mais vous n'avez pas encore complété le
                  formulaire RDO. Veuillez suivre les étapes ci-dessous.
                </span>
              </p>
            )}
            {!isAccountFinished ? (
              <EtapeParcours titre="Identification">
                <FormAccount
                  formData={formData}
                  isAccountFinished={isAccountFinished}
                  setIsAccountFinished={setIsAccountFinished}
                  setUserData={setUserData}
                  setUserCreated={setUserCreated}
                  origin={origin}
                />
              </EtapeParcours>
            ) : !isDspFinished ? (
              <EtapeParcours titre="Recueil des données d'orientation">
                <div className="encart parcours__encart">
                  <i className="fa fa-info-circle" aria-hidden="true" />
                  <p>
                    Afin de mieux comprendre vos aspirations personnelles, vos attentes, vos besoins, vous
                    apporter le meilleur accompagnement possible… Nous avons à présent besoin que vous
                    complétiez ce questionnaire d’orientation. Vos réponses sont nécessaires pour
                    déterminer l’organisme le plus adapté à votre accompagnement, selon votre situation
                    personnelle et professionnelle.
                  </p>
                </div>
                <FormGenerator
                  formDataUrl={api_url + "rdsp/"}
                  isDspFinished={isDspFinished}
                  setIsDspFinished={setIsDspFinished}
                  setFormData={setFormData}
                  withContinue={false}
                  specialCaseRDSP={true}
                  additionalDataToSave={{ user: userData.id }}
                  setRdspForm={setRdspForm}
                />
              </EtapeParcours>
            ) : !isRdvFinished ? (
              <EtapeParcours titre="Récapitulatif">
                <FormRdv
                  isRdvFinished={isRdvFinished}
                  setIsRdvFinished={setIsRdvFinished}
                  rdspId={formData.id}
                  reset={reset}
                  userData={userData}
                  userCreated={userCreated}
                  formData={formData}
                  hasDroit={hasDroit}
                  isConjoint={isConjoint}
                  origin={origin || ""}
                />
                {formData && (
                  <div className="parcours__telechargement">
                    <button type="button" className="btn btn-ghost" onClick={() => setShowDl(true)}>
                      <i className="fa fa-download mr-2" aria-hidden="true" />
                      Télécharger mes réponses au formulaire RDSP
                    </button>
                    {showDl && (
                      <Suspense fallback={<Loader />}>
                        <FormViewerPdf form={rdspForm} answers={formData.rdsp} recipient={userData} />
                      </Suspense>
                    )}
                  </div>
                )}
              </EtapeParcours>
            ) : (
              <EtapeParcours titre="Terminé">
                <p className="parcours__fin">Votre parcours est terminé.</p>
              </EtapeParcours>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default FormRDSP;
